import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router'
import Login from '@/views/login/LoginPage.vue'
import NotFound from '@/views/errors/NotFountPage.vue'
import Layout from '@/layout/MyLayout.vue'

const routes: Array<RouteRecordRaw> = [
  // 根路由重定向到后台管理
  {
    path: '/',
    redirect: '/admin/dashboard'
  },
  // 后台管理路由（管理员）
  {
    path: '/admin',
    redirect: '/admin/dashboard',
    name: 'admin',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/admin/DashboardPage.vue'),
        meta: { title: '后台首页', requiresAuth: true }
      },
      // 甲醛检测业务路由
      {
        path: 'device/list',
        name: 'DeviceList',
        component: () => import('@/views/device/DeviceListPage.vue'),
        meta: { title: '设备列表', requiresAuth: true }
      },
      {
        path: 'device/detail/:id',
        name: 'DeviceDetail',
        component: () => import('@/views/device/DeviceDetailPage.vue'),
        meta: { title: '设备详情', requiresAuth: true }
      },
      {
        path: 'data/records',
        name: 'RecordList',
        component: () => import('@/views/data/RecordListPage.vue'),
        meta: { title: '检测数据', requiresAuth: true }
      },
      {
        path: 'data/calibration',
        name: 'CalibrationList',
        component: () => import('@/views/data/CalibrationListPage.vue'),
        meta: { title: '标定记录', requiresAuth: true }
      },
      {
        path: 'alarm/list',
        name: 'AlarmList',
        component: () => import('@/views/alarm/AlarmListPage.vue'),
        meta: { title: '报警管理', requiresAuth: true }
      },
      {
        path: 'content/manage',
        name: 'ContentManage',
        component: () => import('@/views/content/ContentManagePage.vue'),
        meta: { title: '内容管理', requiresAuth: true }
      },
      {
        path: 'factory/device',
        name: 'FactoryDevice',
        component: () => import('@/views/factory/FactoryDevicePage.vue'),
        meta: { title: '出厂登记', requiresAuth: true }
      },
      {
        path: 'system/role',
        name: 'RoleManagement',
        component: () => import('@/views/system/role/RoleManagementPage.vue'),
        meta: { title: '角色管理', requiresAuth: true }
      },
      {
        path: 'system/wx-user',
        name: 'WxUserManagement',
        component: () => import('@/views/system/user/WxUserManagementPage.vue'),
        meta: { title: '微信用户', requiresAuth: true }
      }
    ]
  },
  // 登录
  {
    path: '/login',
    component: Login,
    meta: { title: '登录' }
  },
  // 404
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
    name: 'NotFound'
  }
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: routes
})

export default router
